export default {
  创作即收益: "สร้างสรรค์ผลงาน <br />รับรายได้ทุกเดือน",
  加入EBC创作者激励计划: "เข้าร่วมโปรแกรมครีเอทีฟของ EBC เปลี่ยนพลังการสร้างสรรค์ของคุณให้กลายเป็นรายได้",
  成为创作者: "เข้าร่วมเลย",
  无限奖励: "รางวัลไม่อั้น สนั่นทั่วโลก",
  EBC创作者激励计划:
    "ขยายผลงานสู่ระดับโลก พร้อมรับรางวัลรายเดือนกับโปรแกรมครีเอทีฟ",
  推荐奖励: "รางวัลจากการแนะนำ",
  推荐新用户注册并交易: "แนะนำเพื่อนใหม่มาสมัครและเทรด พร้อมรับรางวัลทุกเดือน",
  内容变现: "สร้างรายได้จากเนื้อหา",
  在EBC: "เปลี่ยนเนื้อหาคุณภาพให้กลายเป็นรายได้ที่มั่นคง",
  内容进阶: "เผยแพร่ผลงานสู่ระดับโลก",
  从本地创作到全球影响: "สร้างสรรค์ผลงานของคุณ ก้าวสู่ผู้ชมทั่วโลก ปลดล็อกโอกาสไม่จำกัด",
  预计奖金: "เงินรางวัลที่คาดว่าจะได้รับ/เดือน",
  均值估算仅供参考: "ค่าเฉลี่ยโดยประมาณเพื่อการอ้างอิงเท่านั้น",
  "800万交易者的信任首选": "แพลตฟอร์มเทรดระดับโลกที่เทรดเดอร์กว่า 5 ล้านคนไว้วางใจ",
  EBC用全球最佳券商的实力:
    "ในฐานะโบรกเกอร์ที่ดีที่สุด เราเปลี่ยนพลังสร้างสรรค์ของคุณให้กลายเป็นรายได้ พร้อมมอบรางวัลสุดพิเศษและโอกาสระดับโลก",
  全方位媒体曝光: "การเผยแพร่สื่ออย่างครบวงจร",
  我们以全球媒体资源:
    "เรานำสื่อระดับโลกและกิจกรรมสุดพิเศษที่จัดร่วมกับสโมสรฟุตบอลบาร์เซโลนมาสนับสนุนครีเอเตอร์ด้านเนื้อหา เพื่อให้คุณสร้างตัวตนและเพิ่มการมองเห็นได้อย่างเต็มที่",
  全球最强交易环境: "สภาพแวดล้อมการเทรดที่เหนือชั้น",
  打造极致交易体验:
    "เทรดด้วยความเร็วระดับมิลลิวินาที สภาพคล่องระดับสถาบัน และระบบ Copy Trading คุณภาพสูง",
  专属客户经理: "ผู้จัดการบัญชีส่วนตัว",
  我们为每位创作者配专属运营:
    "ครีเอเตอร์ทุกคนจะได้รับคำแนะนำแบบตัวต่อตัวตลอดกระบวนการ ช่วยให้คุณสร้างเนื้อหาได้อย่างมีประสิทธิภาพ พร้อมความช่วยเหลือแบบมืออาชีพ เพื่อเพิ่มรายได้สูงสุด",
  如何成为创作者: "วิธีเข้าร่วมเป็นครีเอเตอร์",
  从内容创作到奖励提现: "รับคำแนะนำจากที่ปรึกษาส่วนตัวตลอดทุกขั้นตอน ตั้งแต่การสร้างสรรค์เนื้อหาไปจนถึงการรับรางวัล",
  立即加入:"เข้าร่วมเลย",
  注册提交资料:"สมัครและส่งข้อมูล",
  发布专业内容:"สร้างสรรค์และเผยแพร่เนื้อหา",
  获取月度奖励:"รับรางวัลรายเดือน",
  活动须知:"ข้อกำหนดของโปรแกรม",
  notices:[
    "1. ครีเอเตอร์ต้องมีคอลัมน์เนื้อหา บัญชีโซเชียลมีเดีย หรือช่องทางของตัวเอง และสามารถสร้างเนื้อหาอย่างต่อเนื่องอย่างน้อย 3 เดือน รูปแบบเนื้อหา เช่น การวิเคราะห์กลยุทธ์ การอธิบายภาพ หรือหลักสูตรการสอน",
    "2. เนื้อหาต้องเป็นต้นฉบับ มีความเป็นมืออาชีพ และถูกต้องตามกฎหมาย หากพบการลอกเลียนแบบ หรือเผยแพร่เนื้อหาที่ไม่เหมาะสม แพลตฟอร์มมีสิทธิ์ยกเลิกการเข้าร่วมและสิทธิประโยชน์ที่เกี่ยวข้อง",
    "3. การจ่ายรางวัลรายเดือนจะขึ้นอยู่กับระดับความสำเร็จของครีเอเตอร์ ผู้ที่ผ่านเกณฑ์จะได้รับรางวัลในสัปดาห์แรกของเดือนถัดไป",
    "4. โปรแกรมนี้ไม่สามารถเข้าร่วมพร้อมกับโปรแกรมมาสเตอร์ หรือโปรแกรมอื่นๆ ได้ ครีเอเตอร์สามารถเลือกได้เพียงโปรแกรมใดโปรแกรมหนึ่งเท่านั้น",
    `5. แพลตฟอร์มพร้อมสนับสนุนและมอบความช่วยเหลือด้านการดำเนินงานโดยเฉพาะสำหรับผู้สร้างสรรค์เนื้อหาที่มีผลงานโดดเด่น รวมทั้งด้านเนื้อหาและทรัพยากรเพื่อให้เกิดผลลัพธ์ที่ดี คุณสามารถติดต่อฝ่ายบริการลูกค้าหรือส่งอีเมลมาที่ <a href="mailto:mkt@ebc.com">mkt@ebc.com</a> เพื่อสอบถามข้อมูลได้
              `,
    "6. เพื่อความเป็นธรรม EBC มีอำนาจสูงสุดในการตัดสินเกี่ยวกับกิจกรรมนี้ และสามารถตัดสิทธิ์ผู้เข้าร่วมที่ฝ่าฝืนกฎหรือใช้งานไม่เหมาะสม"
  ],
  section4Tips:"EBC คว้ารางวัลต่อเนื่อง 3 ปีซ้อนจาก World Finance ในฐานะแพลตฟอร์มเทรด Forex ที่ดีที่สุด ปี 2023, โบรกเกอร์ CFD ที่ดีที่สุด ปี 2024, โบรกเกอร์ที่น่าเชื่อถือที่สุด ปี 2025 พร้อมรางวัลผู้ให้บริการ CFD ดีเด่นจาก Online Money Awards ปี 2025"
};
